<bootstrap-popup [id]="id" [title]="popupTitle" [modalSize]="'modal-lg'" [displaySubject]="displaySubject">
	<form role="form" class="form-horizontal" *ngIf="loaded">
		<div class="form-group">
			<label for="heure" class="col-md-4 control-label">Le&nbsp;:</label>
			<div class="col-md-2 plus-half">
				<date-input 
					[id]="'date'"
					[localDate]="date$ | async"
					(localDateChange)="date$.next($event)"
				>
				</date-input>
			</div>
			<label for="date" class="col-md-1 control-label">&Agrave;&nbsp;:</label>
			<div class="col-md-1">
				<time-input
					[id]="'heure'"
					[stepMinute]="1"
					[localTime]="heure$ | async"
					(localTimeChange)="heure$.next($event)"
					>
				</time-input>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="form-group text-center">
					<button
						type="button"
						class="btn btn-light"
						style="margin-right: 6px"
						(click)="onCancelRequested()"
						>
						Annuler
					</button>
					<button
						type="button"
						class="btn btn-success"
						style="margin-right: 6px"
						[disabled]="waitingForServer"
						(click)="onYes()"
						>
						Oui
					</button>
					<button
						type="button"
						class="btn btn-danger"
						style="margin-right: 6px"
						[disabled]="waitingForServer"
						(click)="onNo()"
						>
						Non
					</button>
					<button
						type="button"
						class="btn btn-warning"
						style="margin-right: 6px"
						[disabled]="waitingForServer"
						(click)="onMessage()"
						>
						Message r&eacute;pondeur
					</button>
				</div>
			</div>
		</div>
	</form>
</bootstrap-popup>